<ng-template #content let-customer="customer">
  <h1 class="ibk-title">Ingresa los datos de tu negocio<span class="dots">:</span></h1>
  <ng-container *ngIf="hasPersonalDataForm">
    <div class="ba-field-group" formGroupName="personalData">
      <ibk-input-group>
        <label>Número de RUC (*)</label>
        <ibk-input class="field" char-filter="^[0-9]{1,8}$">
          <input [attr.disabled]="true" id="ruc-number" type="text" class="field" formControlName="ruc" maxlength="11" />
        </ibk-input>
      </ibk-input-group>
    </div>
    <p class="error-message" *ngIf="form.get('personalData.ruc')?.errors">Ingresa un RUC válido</p>

    <div class="ba-field-group" formGroupName="personalData">
      <ibk-input-group>
        <label>Nombre comercial de tu negocio (*)</label>
        <ibk-input class="field">
          <input id="business-name" type="text" class="field" formControlName="businessName" />
        </ibk-input>
      </ibk-input-group>
    </div>
  </ng-container>

  <ng-container *ngIf="isClient && hasPersonalDataForm" formGroupName="personalData">
    <h1 class="ibk-title">Datos de contacto</h1>
    <div class="ba-field-group">
      <ibk-input-group>
        <label>Número de celular</label>
        <ibk-input class="field">
          <input 
          type="text" 
          id="phone-number" 
          [attr.disabled]="isClient || null" 
          class="field"
          formControlName="phoneNumber" 
          maxlength="9" 
          />
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Operador</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="phoneCarrier">
          <ibk-select-option 
          *ngFor="let option of paramsService.params$('mobileOperator') | async"
          [value]="option.value" 
          [label]="option.label"
            ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
    </div>
    <p class="error-message" *ngIf="form.get('personalData.phoneNumber')?.errors?.['pattern']">
      Ingresa un teléfono válido
    </p>
    <div class="ba-field-group">
      <ibk-input-group>
        <label>Email</label>
        <ibk-input class="field">
          <input type="text" id="email" class="field" [attr.disabled]="haveEmail" formControlName="email" />
        </ibk-input>
      </ibk-input-group>
    </div>
    <ibk-input>
      <input type="checkbox" formControlName="isPEP" (change)="chkPep($event)"/>
      Soy una persona políticamente expuesta (PEP).
    </ibk-input>
    <ng-container *ngIf="personalDataForm.get('pepLegalRepresentative')" formGroupName="pepLegalRepresentative">
      <ba-pep-partners-list-form></ba-pep-partners-list-form>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!isClient && hasPersonalDataForm" formGroupName="personalData">
    <h1 class="ibk-title">Datos personales</h1>
    <div class="ba-field-group">
      <ibk-input-group>
        <label>Primer nombre (*)</label>
        <ibk-input class="field">
          <input class="field" maxlength="20" formControlName="firstName" id="" firstName />
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Segundo nombre</label>
        <ibk-input class="field">
          <input class="field" maxlength="20" formControlName="middleName" id="middleName" />
        </ibk-input>
      </ibk-input-group>
    </div>

    <div class="ba-field-group">
      <ibk-input-group>
        <label>Apellido paterno (*)</label>
        <ibk-input class="field">
          <input class="field" maxlength="20" formControlName="lastName" id="lastName" />
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Apellido materno (*)</label>
        <ibk-input class="field">
          <input class="field" maxlength="20" formControlName="motherLastName" id="motherLastName" />
        </ibk-input>
      </ibk-input-group>
    </div>

    <div class="ba-field-group">
      <ibk-input-group>
        <label>Fecha de nacimiento</label>
        <ibk-input icon="event">
          <input id="birthday" class="field" readonly #endDate appDatePickerControl formControlName="birthDate" />
          <ibk-date-picker [el]="endDate" [config]="ibkConfig"></ibk-date-picker>
        </ibk-input>
      </ibk-input-group>

      <ibk-input-group>
        <label>Sexo (*)</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="gender">
          <ibk-select-option 
            *ngFor="let option of paramsService.params$('gender') | async" 
            [value]="option.value"
            [label]="option.label"
            ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
    </div>

    <div class="ba-field-group">
      <ibk-input-group>
        <label>Estado civil</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="maritalStatus">
          <ibk-select-option 
          *ngFor="let option of paramsService.params$('maritalStatus') | async"
            [value]="option.value" 
            [label]="option.label"
            ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
      <ibk-input-group>
        <label>Email</label>
        <ibk-input class="field">
          <input 
            type="text" 
            id="email" 
            class="field" 
            formControlName="email"
            minlength="3" 
          />
        </ibk-input>
      </ibk-input-group>
    </div>

    <ibk-input>
      <input type="checkbox" formControlName="isPEP" (change)="chkPep($event)"/>
      Soy una persona políticamente expuesta (PEP).
    </ibk-input>

    <ng-container *ngIf="personalDataForm.get('pepLegalRepresentative')" formGroupName="pepLegalRepresentative">
      <ba-pep-partners-list-form></ba-pep-partners-list-form>
    </ng-container> 

    <div class="ba-field-group">
      <ibk-input-group>
        <label>Número de celular</label>
        <ibk-input class="field">
          <input 
          type="text" 
          id="phone-number" 
          [attr.disabled]="null" 
          class="field" 
          formControlName="phoneNumber"
          maxlength="9" 
            />
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Operador</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="phoneCarrier">
          <ibk-select-option 
          *ngFor="let option of paramsService.params$('mobileOperator') | async"
            [value]="option.value" 
            [label]="option.label"
            ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
    </div>
    <p class="error-message" *ngIf="form.get('personalData.phoneNumber')?.errors?.['pattern']">
      Ingresa un teléfono válido
    </p>

    <h1 class="ibk-title">Datos de tu domicilio</h1>

    <div class="ba-field-group">
      <ibk-input-group>
        <label>Departamento (*)</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="department">
          <ibk-select-option 
          *ngFor="let option of paramsService.params$('departments') | async" 
          [value]="option.value"
          [label]="option.label"
            ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
      <ibk-input-group>
        <label>Provincia (*)</label>
        <ng-container *ngIf="provinces$ | async as provinces; else disabledSelector">
          <ibk-select class="field" dsRxForm="selectChange" formControlName="province">
            <ibk-select-option 
            *ngFor="let option of provinces" 
            [value]="option.value"
            [label]="option.label"
            ></ibk-select-option>
          </ibk-select>
        </ng-container>
      </ibk-input-group>
      <ibk-input-group>
        <label>Distrito (*)</label>
        <ng-container *ngIf="districts$ | async as districts; else disabledSelector">
          <ibk-select class="field" dsRxForm="selectChange" formControlName="district">
            <ibk-select-option 
            *ngFor="let option of districts" 
            [value]="option.value"
            [label]="option.label"
            ></ibk-select-option>
          </ibk-select>
        </ng-container>
      </ibk-input-group>
    </div>
    <div class="ba-field-group">
      <ibk-input-group>
        <label>Tipo de via</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="streetType">
          <ibk-select-option 
          *ngFor="let option of paramsService.params$('streetType') | async" 
          [value]="option.value"
          [label]="option.label"
          ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
      <ibk-input-group>
        <label>Nombre de via</label>
        <ibk-input class="field">
          <input class="field" formControlName="streetName" id="streetName" />
        </ibk-input>
      </ibk-input-group>
    </div>
    <div class="ba-field-group">
      <ibk-input-group>
        <label>Número (*)</label>
        <ibk-input class="field">
          <input class="field" formControlName="streetNumber" id="streetNumber" />
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Manzana</label>
        <ibk-input class="field">
          <input class="field" formControlName="block" id="block" />
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Lote</label>
        <ibk-input class="field">
          <input class="field" formControlName="lot" id="lot" />
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Interior</label>
        <ibk-input class="field">
          <input class="field" formControlName="apartment" id="apartment" />
        </ibk-input>
      </ibk-input-group>
    </div>
    <div class="ba-field-group">
      <ibk-input-group>
        <label>Vecindario</label>
        <ibk-input class="field">
          <input class="field" formControlName="neighborhood" id="neighborhood" />
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Referencia</label>
        <ibk-input class="field">
          <input class="field" formControlName="landmark" id="landmark" />
        </ibk-input>
      </ibk-input-group>
    </div>
  </ng-container>

  <ba-outside-tax *ngIf="showOutsideTax"> Tengo residencia fiscal o tributaria en el Perú: </ba-outside-tax>

  <!-- <ba-tax-country-detail-form *ngIf="formHasCountryTaxForm"></ba-tax-country-detail-form> -->

  <ibk-toast type="INFO" *ngIf="showContinueDisclaimer">
    Al marcar "Si" declaro bajo juramento que la informaci&oacute;n proporcionada es veraz, completa y actualizada,
    de
    conformidad con la Ley 26702 (Ley General del Sistema Financiero) y el Decreto Supremo 256-2018-EF
    (Informaci&oacute;n
    financiera que los bancos deben comunicar a SUNAT).
  </ibk-toast>

  <ibk-toast type="ERROR" *ngIf="showErrorDisclaimer">
    Lo sentimos, la creaci&oacute;n de esta cuenta requiere que tu empresa posea residencia y obligaciones fiscales y
    tributarias solo en Per&uacute;.
  </ibk-toast>

  <div class="ba-field-group" formGroupName="sectorData">
    <ibk-input-group>
      <label>Selecciona el rubro de tu negocio (*)</label>
      <ibk-select class="field" dsRxForm="selectChange" formControlName="sectorCode">
        <ibk-select-option *ngFor="let option of rubros" [value]="option.value" [label]="option.label">
        </ibk-select-option>
      </ibk-select>
    </ibk-input-group>

    <ibk-input-group *ngIf="subrubrosList.length > 0">
      <label>Selecciona la actividad de tu negocio</label>
      <ibk-select 
        class="field" 
        dsRxForm="selectChange" 
        formControlName="subSectorCode"
        [disabled]="subrubrosList.length === 0"
        >
        <ibk-select-option *ngFor="let option of subrubrosList" [value]="option.value" [label]="option.label">
        </ibk-select-option>
      </ibk-select>
    </ibk-input-group>
    <span *ngIf="subrubrosList.length === 0"></span>
  </div>

  <ibk-button class="ba-action">
    <button 
      [disabled]="form.invalid" 
      id="go-to-new-account" 
      (click)="done()"
      class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn"
      >
      Continuar
    </button>
  </ibk-button>

  <ng-template #disabledSelector>
    <ibk-select disabled class="field"></ibk-select>
  </ng-template>
</ng-template>

<ng-container *ngTemplateOutlet="content; context: { customer: (customer$ | async)?.customer }"> </ng-container>
